import React from 'react';
import PatientFormTemplate from './components/PatientFormTemplate';

export default function PatientDevelopmentalHistoryForm() {
    return (
        <PatientFormTemplate formTitle="Your Childhood" />
    );
}